/* tslint:disable: component-class-suffix */

import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostBinding,
    Inject,
    OnInit,
    Optional,
    ViewEncapsulation,
} from '@angular/core';

import {
    DOCUMENT,
} from '@angular/common';

import {
    FocusTrapFactory,
} from '@angular/cdk/a11y';

import {
    MatDialogConfig,
} from '@angular/material/dialog';

import {
    Observable,
} from 'rxjs';

import {
    ImageFile,
    SecureImageService,
} from '@nymos/theme/core';

import {
    thmDialogAnimation as thmAnimation,
} from '../../animations/dialog.animations';

import {
    DialogContainer,
} from '../dialog.container';

import { saveAs } from 'file-saver';

@Component({
    selector: 'thm-preview-dialog',
    templateUrl: './preview.container.html',
    styleUrls: ['./preview.container.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        thmAnimation.dialogContainer,
        thmAnimation.downloadingImage,
        thmAnimation.slideDown,
    ],
})
export class PreviewContainer extends DialogContainer implements OnInit {

    private _index: number = 0;

    public downloadEnabled : boolean = false;

    @HostBinding('class.thm-preview-dialog')
    protected get classes(): boolean { return true; }

    protected downloading: boolean = true;

    protected url$: Observable<ImageFile>;

    protected get name(): string { return this.data.urls[this._index].name; }

    protected get contentType(): string { return this.data.urls[this._index].content_type; }

    public documentSrc : any;

    public constructor(
        _er: ElementRef,
        _ft: FocusTrapFactory,
        _conf: MatDialogConfig,
        private _chRef: ChangeDetectorRef,
        @Optional() @Inject(DOCUMENT) _doc: any,
        private _secureService: SecureImageService,
    ) {
        super(_er, _ft, _conf, _chRef, _doc);
    }

    public ngOnInit(): void {
        this._setIndex(this.data.index);
        this.downloadEnabled = this.data.downloadEnabled;
    }

    protected loaded(event: Event): void {
        this.downloading = false;
    }

    protected isFirst(): boolean {
        return this._index === 0;
    }

    protected isLast(): boolean {
        return this._index === this.data.urls.length - 1;
    }

    protected back(): any {
        this._setIndex(this._index - 1);
    }

    protected next(): any {
        this._setIndex(this._index + 1);
    }

    private _setIndex(index: number): void {
        this.downloading = true;

        this._index = index;
        this._index = Math.max(this._index, 0);
        this._index = Math.min(this._index, this.data.urls.length - 1);
        
        if(this.contentType === 'application/pdf'){
            this._secureService.getDocument(this.data.urls[this._index].url).subscribe(res => {
                let blobFile = new Blob([res], { type: 'application/pdf' });
                let blobUrl = URL.createObjectURL(blobFile);
                this.documentSrc = blobUrl;
                this.downloading = false;
                this._chRef.detectChanges();
            }, (err => {
                this.downloading = false;
            }));
            
        }
        else if(this.contentType === 'application/msword' || this.contentType === 'application/octet-stream'){
            // this._secureService.getDocument(this.data.urls[this._index].url).subscribe(res => {
            //     console.log(res);
            //     let blobFile = new Blob([res], { type: 'application/msword' });
            //     let blobUrl = URL.createObjectURL(blobFile);
            //     this.documentSrc = blobUrl;
            // }, (err => {
            //     console.log(err);
            // }));
            this.downloading = false;
            this._chRef.detectChanges();
        }
        else{
            this.url$ = this._secureService.get(this.data.urls[this._index].url);
            this._chRef.detectChanges();
        }
    }

    download(event: Event){
        this._secureService.get(this.data.urls[this._index].downloadUrl).subscribe(res => {
            let image$ = res;
            let file = this.convertBase64ToFile(image$.base64, this.data.urls[this._index].name);
            saveAs(file, this.data.urls[this._index].name);
        }, (err => {
            console.log(err);
        }));
    }

    convertBase64ToFile(base64String, fileName){
        let arr = base64String.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let uint8Array = new Uint8Array(n);
        while (n--) {
           uint8Array[n] = bstr.charCodeAt(n);
        }
        let file = new File([uint8Array], fileName, { type: mime });
        return file;
    }
}
